/**
 * 跳转到新页面
 * 未指定target时会在新页面打开
 * @param url
 * @param target 同a标签的target 默认为 _blank
 * @param rel 同a标签的rel
 */
export const jumpToNewPage = (url: string, target?: string, rel?: string): void => {
    const aElement = document.createElement('a');
    aElement.style.display = 'none';
    aElement.href = url;
    aElement.target = target ?? '_blank';

    if (rel) {
        aElement.rel = rel;
    }

    document.body.appendChild(aElement);
    aElement.click();
    document.body.removeChild(aElement);
};
